<template>
  <div class="c-comment">
    <div
      class="avatar"
      :style="{
        backgroundImage: `url(${comment.user_info.avatar || images.avatar})`,
      }"
      @click="onUserClick(comment.user_info.uuid)"
    ></div>
    <div class="info">
      <span class="nickname" @click="onUserClick(comment.user_info.uuid)">{{
        comment.user_info.nickname
      }}</span>
      <span v-if="isReplyToReply" class="reply-to">
        {{ $t("reply") }}
        <span class="nickname" @click="onUserClick(replyTo.uuid)">{{
          replyTo.nickname
        }}</span>
      </span>
      <span class="dot">·</span>
      <span class="time">{{ time }}</span>
      <div class="text">{{ comment.content }}</div>
      <div class="reply">
        <i class="iconfont iconhuifu" @click="toReply" />{{
          comment.reply_count || ""
        }}
      </div>
      <md-field v-show="replyVisibled" class="textarea">
        <md-textarea ref="reply" v-model="reply" maxlength="200"></md-textarea>
      </md-field>
      <div v-show="replyVisibled" class="buttons">
        <md-button class="cancel" @click="onReplyCancel">{{
          $t("cancel")
        }}</md-button>
        <md-button class="submit" @click="onReply" :disabled="!reply.trim()">{{
          $t("submit")
        }}</md-button>
      </div>
    </div>
    <div class="reply-list" :class="{ 'is-reply': isReply }">
      <c-comment
        isReply
        :isReplyToReply="isReply"
        v-for="item in replyList"
        :key="item.id"
        :led="led"
        :comment="item"
        :replyTo="{
          user_uuid: comment.user_info.uuid,
          avatar: comment.user_info.avatar,
          nickname: comment.user_info.nickname,
        }"
        @reply="$emit('reply')"
      />
      <md-button
        v-if="replyList.length !== count"
        class="more"
        @click="onShowMore"
        >{{ $t("showMore") }}</md-button
      >
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";
import api from "@/api";
export default {
  name: "CComment",
  props: {
    led: Object,
    comment: Object,
    isReply: Boolean,
    isReplyToReply: Boolean,
    replyTo: Object,
  },
  data() {
    return {
      replyVisibled: false,
      reply: "",
      replyList: [],
      page: 1,
      count: 0,
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("user", {
      isSignIn: "isSignIn",
    }),
    time() {
      return this.comment.create_time
        ? moment(this.comment.create_time).fromNow()
        : " ";
    },
  },
  methods: {
    getReplyList(page = 1) {
      api
        .getCommentList({
          content_type: "diy_led",
          object_id: this.led.id,
          superior_id: this.comment.id,
          page_number: page,
          page_size: 5,
          ordering: "-id",
        })
        .then((res) => {
          res.results = res.results || [];
          this.replyList =
            page === 1 ? res.results : [...this.replyList, ...res.results];
          this.page = page;
          this.count = res.count;
        });
    },
    toReply() {
      this.replyVisibled = !this.replyVisibled;
      setTimeout(() => {
        this.$refs.reply.$el.focus();
      }, 200);
    },
    onReply() {
      api
        .addComment({
          content_type: "diy_led",
          object_id: this.led.id,
          superior_id: this.comment.id,
          content: this.reply.trim(),
        })
        .then(() => {
          this.getReplyList();
          this.replyVisibled = false;
          this.reply = "";
          this.comment.reply_count += 1;
          this.$emit("reply");
        });
    },
    onReplyCancel() {
      this.replyVisibled = false;
      this.reply = "";
    },
    onShowMore() {
      this.getReplyList(this.page + 1);
    },
    onUserClick(uuid) {
      this.$router.push({
        path: this.$paths.user.replace(":uuid", uuid),
      });
    },
  },
  mounted() {
    this.getReplyList();
  },
};
</script>
<style lang="scss" scoped>
.c-comment {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;

  .avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: $primary-color no-repeat center / cover;
    border: 1px solid $primary-color;
    margin-right: 20px;
    flex: none;
    cursor: pointer;
  }

  .info {
    width: 50%;
    flex: auto;
    display: flex;
    flex-wrap: wrap;

    .nickname,
    .reply-to,
    .dot,
    .time {
      flex: none;
      font-size: 14px;
      color: #aaaaaa;
    }

    .nickname {
      font-weight: bold;
      color: #ffffff;
      cursor: pointer;
    }

    .reply-to {
      margin-left: 10px;
    }

    .dot {
      margin: 0 10px;
      cursor: auto;
    }

    .time {
      width: 50%;
      flex: auto;
    }

    .text {
      width: 100%;
      flex: none;
      font-size: 14px;
      color: #ffffff;
      word-break: break-all;
    }

    .reply {
      @include flex-center;
      color: #ffffff;
      font-size: 12px;
      cursor: pointer;
      margin-right: 20px;

      &:hover {
        color: $primary-color;
      }

      i {
        font-size: 20px;
        margin-right: 10px;
      }
    }

    .textarea {
      padding-top: 5px;
      margin-bottom: 10px;

      textarea {
        min-height: 70px;
        color: #ffffff;
      }
    }

    .buttons {
      width: 100%;
      @include flex-center;
      justify-content: flex-end;

      .submit {
        margin-right: 0;
        background-color: $primary-color;
      }
    }
  }

  .reply-list {
    width: 100%;
    padding-left: 70px;
    flex: none;

    &.is-reply {
      padding-left: 0;
    }

    .more {
      width: 150px;
      display: block;
      margin: 0 auto;
      color: $primary-color;
      font-size: 14px;
      text-align: center;
      padding: 10px 0;
      margin-top: 10px;
      cursor: pointer;
    }
  }
}
</style>
